import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const getTimeDisplay = timeLeftMs => {
  const totalSeconds = Math.floor(timeLeftMs / 1000);
  if (totalSeconds <= 0) return '00:00';

  const durationTime = dayjs.duration(totalSeconds, 'seconds');
  const minutes = Math.floor(durationTime.asMinutes()).toString().padStart(2, '0');
  const seconds = durationTime.seconds().toString().padStart(2, '0');

  return `${minutes}:${seconds}`;
};

const useExpirationCountdown = ({ expirationCountdown, expiredAt, onExpire }) => {
  const initialTimeLeft = expirationCountdown * 1000;
  const [timeLeft, setTimeLeft] = useState(() =>
    Math.max(0, Math.min(expiredAt - Date.now(), initialTimeLeft)),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      const remaining = expiredAt - Date.now();
      setTimeLeft(Math.max(0, remaining));
      if (remaining <= 0) {
        clearInterval(timer);
        onExpire();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [expiredAt, onExpire]);

  const isExpired = timeLeft <= 0;
  const timeDisplay = getTimeDisplay(timeLeft);
  const timerProgress = Math.min(1, timeLeft / initialTimeLeft);

  return { isExpired, timeDisplay, timerProgress };
};

export default useExpirationCountdown;
